import { Injectable } from '@angular/core';
import * as singalR from "@microsoft/signalr";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SingalRService {

  private hubConnection!: signalR.HubConnection;
  private readonly addtoGroupMethod: string = "AddToGroup";
  private readonly statusListener: string = "deliveryStatus";

  constructor() { }

  public startConnection = () => {
    this.hubConnection = new singalR.HubConnectionBuilder()
                                    .withUrl(`${environment.apiBaseUrl}/${this.statusListener}`)
                                    .withAutomaticReconnect()
                                    .build();
  }

  public addToGroupWithStart(groupName: string) {
    this.hubConnection.start().then(
      () => {
        this.hubConnection.invoke(this.addtoGroupMethod, groupName);
        console.log('connection started with groups');
      })
      .catch(err => {
        console.log(err);
      });
  }

  public getHubConnection(): signalR.HubConnection {
    return this.hubConnection;
  }
}
